import React from "react";
import PropTypes from "prop-types";
import DateTd from "../../table-componets/DateTd.js";
import LinkTd from "../../table-componets/LinkTd.js";
import axios from "axios";
import { DATE } from "../../../utils/dateFormats";

const EditFields = ({
  certification,
  latestCertificationStepResult,
  handleInputChange,
  programDirectors,
  instructorTrainers,
  trainingCenters,
  handlerSave,
  index,
  updateCertificationStepResult,
  isSaiAdmin
}) => (
  <React.Fragment>
    <td>
      <input
        className='form-control completed-date-picker'
        type='date'
        onChange={e => handleInputChange(e.target.value, 'completed_on')}
        value={
          latestCertificationStepResult.completed_on ?
          new Date(latestCertificationStepResult.completed_on).toLocaleDateString("en-CA") :
          null
        }
      />
    </td>
    <DateTd
      fieldValue={certification.expiration_date}
      fieldFormat={DATE}
      fieldClassName={certification.expiration_date_color}
      fieldInsideClassName="pull-right"
    />
    <td>
      <select className='form-control'
        name='program_director_id'
        value={latestCertificationStepResult.program_director_id}
        onChange={e => handleInputChange(e.target.value, 'program_director_id')}>
        <option value=''>
          Select a Program Director
        </option>
        {programDirectors.map((programDirector) => (
          <option
            key={programDirector.id}
            value={programDirector.id}
          >
            {programDirector.full_name_reverse}
          </option>
        ))}
      </select>
    </td>
    <td>
      <select className='form-control'
        name='instructor_trainer_id'
        value={latestCertificationStepResult.instructor_trainer_id}
        onChange={e => handleInputChange(e.target.value, 'instructor_trainer_id')}>
        <option value=''>
          Select a Instructor Trainer
        </option>
        {instructorTrainers.map((instructorTrainer) => (
          <option
            key={instructorTrainer.id}
            value={instructorTrainer.id}
          >
            {instructorTrainer.full_name_reverse}
          </option>
        ))}
      </select>
    </td>
    <td>
      <select className='form-control'
        name='training_center_id'
        value={latestCertificationStepResult.training_center_id}
        onChange={e => handleInputChange(e.target.value, 'training_center_id')}>
        <option value=''>
          Select a Training Center
        </option>
        {trainingCenters.map((trainingCenter) => (
          <option
            key={trainingCenter.id}
            value={trainingCenter.id}
          >
            {trainingCenter.name}
          </option>
        ))}
      </select>
    </td>
    <td>
      <a
        className="btn btn-text pull-right"
        onClick={() => {
          handlerSave();
        }}
      >
        SAVE
      </a>
    </td>
  </React.Fragment>
);

const DisplayFields = ({
  certification,
  latestCertificationStepResult,
  toggleEditMode,
  handlerDelete,
  programDirectors,
  instructorTrainers,
  trainingCenters,
  findProgramDirectorName,
  findInstructorTrainerName,
  findTrainingCenterName,
  index
}) => (
  <React.Fragment>
    <DateTd
      fieldValue={latestCertificationStepResult ? latestCertificationStepResult.completed_on : null}
      fieldFormat={DATE}
      fieldClassName="hidden-xs hidden-sm"
      fieldInsideClassName="pull-right"
    />
    <DateTd
      fieldValue={certification.expiration_date}
      fieldFormat={DATE}
      fieldClassName={certification.expiration_date_color}
      fieldInsideClassName="pull-right"
    />
    <td>
      {findProgramDirectorName()}
    </td>
    <td>
      {findInstructorTrainerName()}
    </td>
    <td>
      {findTrainingCenterName()}
    </td>
    <td>
      <a
        className="btn btn-text pull-right"
        href={"/users/" + certification.user_id + "/sai_certifications"}
      >
        EDIT ALL
      </a>
      <a
        className="btn btn-text pull-right"
        onClick={() => {
          toggleEditMode();
        }}
      >
        EDIT
      </a>
    </td>
  </React.Fragment>
);

class CertificationIndexRow extends React.Component {
  state = {
    certification: this.props.certification,
    latestCertificationStepResult: this.props.certification.latest_certification_step_result,
    editMode: false
  };

  componentDidUpdate(prevProps) {
    if(prevProps.certification !== this.props.certification) {
      this.setState({
        certification: this.props.certification,
        latestCertificationStepResult: this.props.certification.latest_certification_step_result
      });
    }
  }

  render() {
    const {
      certification,
      latestCertificationStepResult,
      editMode
    } = this.state;

    const {
      handleInputChange,
      programDirectors,
      instructorTrainers,
      trainingCenters,
      handlerDelete,
      index,
      updateCertificationStepResult,
      isSaiAdmin
    } = this.props;

    return (
      <tr key={index}>
        <LinkTd
          fieldName={
            certification.user.last_name +
            ", " +
            certification.user.first_name
          }
          fieldURL={"/users/" + certification.user_id}
        />
        <td>
          {certification.certification_group && certification.certification_group.name}
          &nbsp;-&nbsp;{certification.certification_type && certification.certification_type.name}
          <br />
          {latestCertificationStepResult && latestCertificationStepResult.name}
        </td>
        {editMode ? (
          <EditFields
            key={index}
            certification={certification}
            latestCertificationStepResult={latestCertificationStepResult}
            programDirectors={programDirectors}
            instructorTrainers={instructorTrainers}
            trainingCenters={trainingCenters}
            index={index}
            handleInputChange={this.handleInputChange}
            handlerSave={this.handlerSave}
            isSaiAdmin={isSaiAdmin}
          />
        ) : (
          <DisplayFields
            key={index}
            certification={certification}
            latestCertificationStepResult={latestCertificationStepResult}
            toggleEditMode={this.toggleEditMode}
            programDirectors={programDirectors}
            instructorTrainers={instructorTrainers}
            trainingCenters={trainingCenters}
            findProgramDirector={this.findProgramDirector}
            findProgramDirectorName={this.findProgramDirectorName}
            findInstructorTrainerName={this.findInstructorTrainerName}
            findTrainingCenterName={this.findTrainingCenterName}
            handlerDelete={handlerDelete}
            index={index}
          />
        )}

      </tr>
    );
  }

  handleInputChange = (newValue, key) => {
    const latestCertificationStepResult = this.state.latestCertificationStepResult;
    !(key in latestCertificationStepResult) && (latestCertificationStepResult[key] = {});
    latestCertificationStepResult[key] = newValue;

    this.setState({ latestCertificationStepResult: latestCertificationStepResult });
    // this.props.onChange(certification, "certification", this.props.index);
  };

  buildDataForm = () => {
    const data = new FormData();

    Object.keys(this.state.latestCertificationStepResult).forEach(key => {
      let value = this.state.latestCertificationStepResult[key];
      data.append(`certification_step_result[${key}]`, value);
    });

    return data;
  };

  handlerSave = () => {
    let that = this;

    if (this.state.loading) {
      return;
    }

    const data = this.buildDataForm();

    this.setState({ loading: true });

    axios.put(
      "certification_step_results/" + this.state.latestCertificationStepResult.id,
      data
    ).then(request => {
      this.props.updateCertificationStepResult(request.data.certification, request.data, this.props.index)
      toastr.success("Step Updated");
      this.setState({ editMode: false, done: true, loading: false });
    })
    .catch(function(error) {
      toastr.error("There is an error, please check");
      that.setState({ loading: false, done: false });
    });
  };

  toggleEditMode = () => {
    this.setState({
      editMode: !this.state.editMode
    })
  };

  findProgramDirectorName = () => {
    var programDirector = this.props.programDirectors.find(
      (programDirector) => this.state.latestCertificationStepResult.program_director_id == programDirector.id
    )
    if (programDirector) {
      return programDirector.full_name_reverse
    } else {
      "error"
    }
  };

  findInstructorTrainerName = () => {
    var instructorTrainer = this.props.instructorTrainers.find(
      (instructorTrainer) => this.state.latestCertificationStepResult.instructor_trainer_id == instructorTrainer.id
    )
    if (instructorTrainer) {
      return instructorTrainer.full_name_reverse
    } else {
      "error"
    }
  };

  findTrainingCenterName = () => {
    var trainingCenter = this.props.trainingCenters.find(
      (trainingCenter) => this.state.latestCertificationStepResult.training_center_id == trainingCenter.id
    )
    if (trainingCenter) {
      return trainingCenter.name
    } else {
      "error"
    }
  };
}

CertificationIndexRow.propTypes = {
  certification: PropTypes.object,
  handlerDelete: PropTypes.func,
  index: PropTypes.number,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  latestCertificationStepResult: PropTypes.object,
  updateCertificationStepResult: PropTypes.func,
  isSaiAdmin: PropTypes.bool
};

export default CertificationIndexRow;
